Vue Pure Lightbox by DCzajkowski
https://github.com/DCzajkowski/vue-pure-lightbox
License: Just use it. For free. Forever. (Really la)
<template lang="pug">
div
  a.lightbox__thumbnail(:href="images[0]" target="_blank" @click.prevent="show")
    img(:src="thumbnail" :alt="alternateText")
  .lightbox(v-if="visible" @click="hide")
    .lightbox__close(@click="hide") &times;
    .lightbox__element(@click.stop="")
      .lightbox__arrow.lightbox__arrow--left(
        :class="{ 'lightbox__arrow--invisible': !hasPrev() }"
        @click.stop.prevent="prev"
      )
        svg(
          height="24"
          width="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        )
          path(d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z")
          path(d="M0-.5h24v24H0z" fill="none")
      .lightbox__image(@click.stop="")
        slot(v-if="$slots.loader" name="loader")
        img(v-if="displayImage" :src="images[index]")
      .lightbox__arrow.lightbox__arrow--right(
        :class="{ 'lightbox__arrow--invisible': !hasNext() }"
        @click.stop.prevent="next"
      )
        svg(
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        )
          path(d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z")
          path(d="M0-.25h24v24H0z" fill="none")
</template>

<script>
export default {
  props: {
    thumbnail: {
      type: String,
      required: true,
    },
    images: {
      type: Array,
      default: () => [],
    },
    alternateText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      index: 0,
      displayImage: true,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown);
  },
  destroyed() {
    window.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    show() {
      this.visible = true;
      this.index = 0;
    },
    hide() {
      this.visible = false;
      this.index = 0;
    },
    hasNext() {
      return this.index + 1 < this.images.length;
    },
    hasPrev() {
      return this.index - 1 >= 0;
    },
    prev() {
      if (this.hasPrev()) {
        this.index -= 1;
        this.tick();
      }
    },
    next() {
      if (this.hasNext()) {
        this.index += 1;
        this.tick();
      }
    },
    async tick() {
      if (!this.$slots.loader) {
        return;
      }
      this.displayImage = false;
      await this.$nextTick();
      this.displayImage = true;
    },
    onKeydown(e) {
      if (!this.visible) return;
      const actionMap = {
        ArrowRight: this.next.bind(this),
        ArrowLeft: this.prev.bind(this),
        ArrowDown: e.preventDefault.bind(this),
        ArrowUp: e.preventDefault.bind(this),
        Escape: this.hide.bind(this),
        ' ': e.preventDefault.bind(this),
      };
      actionMap[e.key]?.();
    },
  },
};
</script>

<style lang="scss" scoped>
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  &__thumbnail {
    width: 100%;
    height: 100%;

    & img {
      width: 100%;
      height: 132px;
      margin: auto;
      object-fit: cover;
    }
  }

  &__close {
    position: fixed;
    right: 0;
    top: 0;
    padding: 1rem;
    font-size: 1.5rem;
    cursor: pointer;
    color: #fff;
    width: 4rem;
    height: 4rem;
  }

  &__arrow--invisible {
    visibility: hidden;
  }

  &__element {
    display: flex;
    width: 100%;
    height: fit-content;
  }

  &__arrow {
    padding: 0 2rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    & svg {
      fill: #fff;
      pointer-events: none;
    }
  }

  &__image {
    flex: 1;

    & img {
      width: 100%;
      height: auto !important;
    }
  }
}

@media screen and (max-width: 720px) {
  .lightbox__arrow {
    padding: 0 1rem;
  }
}

@media screen and (max-width: 500px) {
  .lightbox {
    &__element {
      position: relative;
    }

    &__arrow {
      position: absolute;
      padding: 0 2rem;
      height: 100%;

      &--right {
        right: 0;
        background: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.3));
      }

      &--left {
        left: 0;
        background: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.3));
      }
    }
  }
}
</style>
